'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _utils = require('./utils');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var els = getEls();

  seCarouselWidth();
  makeCarousel();

  /**
   * Initialised the Swiper carousel
   */
  function makeCarousel() {
    (0, _utils.initialiseSwiper)(els.carousel, {
      loop: true,
      centeredSlides: true,
      speed: 500,
      effect: 'fade',
      slideActiveClass: 'hd-AnnouncementBar_Item-active',
      slideClass: context.className + '_Slide',
      autoplay: {
        delay: 5000
      },
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: els.next,
        prevEl: els.prev
      }
    }, ['Navigation', 'Autoplay']);
  }

  /**
   * Sets the Width of the Announcement Bar body to the longest item
   */
  function seCarouselWidth() {
    var longerWidth = getLongerTextWidth();

    if (longerWidth) {
      els.carousel.style.width = longerWidth + 'px';
    }
  }

  /**
   * Returns the longest text slide, to be used to calculate the position
   * of the Control buttons
   *
   * @returns {Number} Width of the longest text element
   */
  function getLongerTextWidth() {
    var longerWidth = 0;

    els.text.forEach(function (text) {
      var width = text.offsetWidth;

      longerWidth = width > longerWidth ? width : longerWidth;
    });

    return Math.ceil(longerWidth);
  }

  /**
   * Gets all useful elements
   *
   * @returns {Object}
   */
  function getEls() {
    return {
      carousel: context.getElement('.' + context.className + '_Carousel'),
      items: context.getElement('.' + context.className + '_Items'),
      text: context.getElements('.' + context.className + '_Text'),
      prev: context.getElement('.' + context.className + '_Prev'),
      next: context.getElement('.' + context.className + '_Next')
    };
  }
}